import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// 기능별 모듈을 묶어만들고 스토어 modules 에 추가하면됨
import countModule from './modules/countModule';
import loginModule from './modules/loginModule';
import alertModule from './modules/alertModule';
import confirmModule from './modules/confirmModule';
import customConfirmModule from './modules/customConfirmModule';
import commonModule from './modules/commonModule';
import selectboxModule from './modules/selectboxModule';
import commonRefreshModule from './modules/commonRefreshModule';
import shopProductListModule from './modules/shopProductListModule';
import asModule from '@/store/modules/asModule';
import mqttAlarmModule from './modules/mqttAlarmModule';
import toolbarModule from './modules/toolbarModule';
import loadingModule from './modules/loadingModule';
import driveMonitoringModule from './modules/driveMonitoringModule';
import timerModule from './modules/timerModule';
import localesModule from './modules/localesModule';
import mqttModule from './modules/mqttModule';
import cartModule from './modules/cartModule';

export default createStore({
  modules: {
    count: countModule,
    login: loginModule,
    alert: alertModule,
    confirm: confirmModule,
    customConfirm: customConfirmModule,
    common: commonModule,
    selectbox: selectboxModule,
    asModule: asModule,
    commonRefresh: commonRefreshModule,
    shopProductList: shopProductListModule,
    mqttAlarm: mqttAlarmModule,
    toolbar: toolbarModule,
    loading: loadingModule,
    driveMonitoring: driveMonitoringModule,
    timer: timerModule,
    locales: localesModule,
    mqtt: mqttModule,
    cart: cartModule,
  },
  plugins: [
    // vuex 값을 로컬스토리지에 저장시킴으로써 새로고침시 값유지시키는 설정 (paths에 선언한모듈만)
    createPersistedState({
      key: 'vuexStore',
      storage: window.localStorage,
      paths: ['login', 'commonRefresh', 'locales', 'timer', 'mqtt', 'cart'], // 로그인 모듈과 장바구니 모듈의 상태를 로컬 스토리지와 동기화
    }),
  ],
});
